import { Box } from '@mui/material';
import { FC, useEffect, useRef, useState } from 'react';

import * as Styled from './styled';

interface IStreamingProps {
	textPieces: Array<string>;
	responseParser: (string: string) => Array<string>;
	existingMessage?: Array<string>;
}

const revealDelay = 10;
const amountOfRevealedSymbols = 1;

export const UserStoriesStreaming: FC<IStreamingProps> = ({
	textPieces,
	responseParser,
	existingMessage,
}) => {
	const [displayedText, setDisplayedText] = useState<string>('');
	const [charIndex, setCharIndex] = useState(0);
	const currentText = useRef('');
	const queueIndex = useRef(0);

	useEffect(() => {
		let timer: NodeJS.Timeout;

		if (displayedText === '') {
			currentText.current = textPieces[queueIndex.current];
		}

		if (charIndex < currentText.current?.length) {
			timer = setTimeout(() => {
				setDisplayedText((prev) => prev + currentText.current[charIndex]);
				setCharIndex(charIndex + amountOfRevealedSymbols);
			}, revealDelay);
		} else if (queueIndex.current < textPieces.length - 1 || textPieces.length === 1) {
			queueIndex.current += 1;
			currentText.current = textPieces[queueIndex.current];
			setCharIndex(0);
		}

		return () => clearTimeout(timer);
	}, [charIndex, textPieces]);

	return (
		<Box sx={{ margin: '16px 0' }} className="rtl-able">
			{[...(existingMessage || []), ...responseParser(displayedText)].map((parsedString, index) => (
				<Styled.StreamingText key={`${index}.${parsedString}`}>{`${
					index + 1
				}.${parsedString}`}</Styled.StreamingText>
			))}
		</Box>
	);
};
